import { RUNDOWN_URL } from "../../helpers/urls";

export const defaultSorted = [{ dataField: "createDate", order: "desc" }];
export const sizePerPageList = [
  { text: "3", value: 3 },
  { text: "5", value: 5 },
  { text: "10", value: 10 },
];
export const initialFilter = {
  filter: {
    searchFilter: "",
  },
  sortOrder: "asc", // asc||desc
  sortField: "placingPoToSupplier",
  pageNumber: 1,
  pageSize: 10,
};

// Delete case
export const setNewQueryParams = (queryParams, totalCount, entities) => {
  const pageSize = queryParams.pageSize;
  const lastPageValue = (totalCount + pageSize - 1) / pageSize;
  const pageNumber = queryParams.pageNumber;
  const res = {
    isRequieredSetQueryParams:
      lastPageValue === pageNumber && entities.length - 1 === 0,
  };
  res.cleanRefFilters = totalCount === 1 ? true : false;
  if (res.isRequieredSetQueryParams) {
    res.queryParams =
      totalCount === 1
        ? { ...initialFilter }
        : { ...queryParams, pageNumber: lastPageValue - 1 };
  }
  return res;
};

export const generateQueryParamsStrings = (objectDataId, objectsData, row) => {
  const indexOfObjectData =
    objectsData.length > 0 &&
    objectsData.findIndex((x) => x.value === objectDataId);
  const data =
    objectsData.length > 0 && indexOfObjectData >= 0
      ? objectsData[indexOfObjectData]
      : null;
  return data !== null
    ? `${RUNDOWN_URL}/countingSheet?Value=${data.objectDataValue}&SearchKey=${data.searchKey}&PurchaseOrderId=${row.purchaseOrderNumber}&Quantity=${row.quantity}`
    : "../error/error500/error";
};
